import { VariableButton } from 'legacy/TemplateCreatorEditor/VariableButton';

export const ListVariableButton = variableButtonProps => (
  <VariableButton
    sx={{ maxWidth: 230 }}
    labelStyles={{ textOverflow: 'ellipsis' }}
    {...variableButtonProps}
  />
);
